import * as React from 'react'
import { Segment, Container, Header, Divider } from 'semantic-ui-react'

export default class ContentMol extends React.Component<
  { title: string; style?: React.CSSProperties },
  {}
> {
  render() {
    return (
      <div>
        <Container>
          <Segment>
            <Header>{this.props.title}</Header>
            <div style={{ ...this.props.style }}>{this.props.children}</div>
          </Segment>
        </Container>
        <br />
      </div>
    )
  }
}
